<template>
    <div class="products-view__options view-options view-options--offcanvas--mobile">
        <div class="view-options__body">
            <button type="button" class="view-options__filters-button filters-button">
                <span class="filters-button__icon">
                    <svg width="16" height="16">
                        <path d="M7,14v-2h9v2H7z M14,7h2v2h-2V7z M12.5,6C12.8,6,13,6.2,13,6.5v3c0,0.3-0.2,0.5-0.5,0.5h-2
        C10.2,10,10,9.8,10,9.5v-3C10,6.2,10.2,6,10.5,6H12.5z M7,2h9v2H7V2z M5.5,5h-2C3.2,5,3,4.8,3,4.5v-3C3,1.2,3.2,1,3.5,1h2
        C5.8,1,6,1.2,6,1.5v3C6,4.8,5.8,5,5.5,5z M0,2h2v2H0V2z M9,9H0V7h9V9z M2,14H0v-2h2V14z M3.5,11h2C5.8,11,6,11.2,6,11.5v3
        C6,14.8,5.8,15,5.5,15h-2C3.2,15,3,14.8,3,14.5v-3C3,11.2,3.2,11,3.5,11z" />
                     </svg>
                </span>
                <span class="filters-button__title">Filters (x)</span>
                <span class="filters-button__counter">3</span>
            </button>
            <div class="view-options__layout layout-switcher">
                <div class="layout-switcher__list">                                                    
                    <button type="button" class="layout-switcher__button layout-switcher__button--active" data-layout="table" data-with-features="false">
                    </button>
                </div>
            </div>
            <div class="view-options__legend">
                <strong>Search Term:</strong> {{ interchange_sku }}
            </div>
            <div class="view-options__legend">
                ({{ interchange_manufacturers.length }} Vendor Results)
            </div>
            <div class="view-options__legend">
                <a href="#" @click.prevent="$router.go(-1)" class="btn btn-xs btn-primary">New Interchange Search</a>
            </div>
            <div class="view-options__spring"></div>
            <div class="view-options__select">
                <label for="view-option-sort">Sort:</label>
                <select id="view-option-sort" class="form-control form-control-sm" name="">
                    <option value="">Availability (x)</option>
                    <option value="">Price (x)</option>
                </select>
            </div>
            <!-- <div class="view-options__select">
                <label for="view-option-limit">Show:</label>
                <select id="view-option-limit" class="form-control form-control-sm" name="">
                    <option value="">View All (x)</option>
                    <option value="">100</option>
                    <option value="">50</option>
                    <option value="">25</option>
                </select>
            </div> -->
        </div>
        <!-- <div class="view-options__body view-options__body--filters">
            <div class="view-options__label">Active Filters (x)</div>
            <div class="applied-filters">
                <ul class="applied-filters__list">
                    <li class="applied-filters__item">
                        <a href="" class="applied-filters__button applied-filters__button--filter">
                            Category: Oil & Lubricants (x)
                            <svg width="9" height="9">
                                <path d="M9,8.5L8.5,9l-4-4l-4,4L0,8.5l4-4l-4-4L0.5,0l4,4l4-4L9,0.5l-4,4L9,8.5z" />
                            </svg>
                        </a>
                    </li>
                    <li class="applied-filters__item">
                        <a href="" class="applied-filters__button applied-filters__button--filter">
                            Color: Blue (x)
                            <svg width="9" height="9">
                                <path d="M9,8.5L8.5,9l-4-4l-4,4L0,8.5l4-4l-4-4L0.5,0l4,4l4-4L9,0.5l-4,4L9,8.5z" />
                            </svg>
                        </a>
                    </li>
                    <li class="applied-filters__item">
                        <button type="button" class="applied-filters__button applied-filters__button--clear">Clear All (x)</button>
                    </li>
                </ul>
                
            </div>
        </div> -->
     </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters("product", [
            "interchange_sku",
            "interchange_manufacturers"
        ])
    }
}
</script>